module.exports = __webpack_public_path__ + "img/o365_group.ad94a245.svg";